module.exports = __webpack_public_path__ + "static/media/life-on-land.79984891.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/life-on-land.png
// module id = 577
// module chunks = 0